import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisIdeasRoute: InvariantJiraRoute = {
	name: 'polaris-ideas',
	path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
	query: ['selectedIssue?', 'issueViewLayout?'],
	exact: true,
};
